// Starts PostHog when GET /v1/config has a key and keeps its idea of who is
// signed in current (TOM-983, cloud ADR 0466). Renders nothing. The rules for
// what leaves the browser live in lib/analytics.ts.

import { useEffect, useState } from 'react';
import type { PostHog } from 'posthog-js';

import { useAuth } from '../auth';
import { startAnalytics, syncIdentity } from '../lib/analytics';
import { useClientConfig } from '../lib/useClientConfig';

export function Analytics(): null {
  const { config } = useClientConfig();
  const { status, user } = useAuth();
  const [client, setClient] = useState<PostHog | null>(null);

  const key = config?.posthogKey ?? null;
  const host = config?.posthogHost ?? null;

  useEffect(() => {
    if (key === null || host === null) return;
    let active = true;
    void startAnalytics(key, host).then((c) => {
      if (active) setClient(c);
    });
    return () => {
      active = false;
    };
  }, [key, host]);

  const userId = user?.id ?? null;
  const email = user?.email ?? null;
  const demo = user?.demo != null;
  useEffect(() => {
    if (client === null) return;
    syncIdentity(
      client,
      status,
      userId === null || email === null ? null : { id: userId, email, demo }
    );
  }, [client, status, userId, email, demo]);

  return null;
}
